import { isMuttavatteenSabilType } from "../sabil-household-members";

/**
 * Mutawatteen sabils store the holder ITS on `sabilData.itsNo`.
 * The holder is entered at sabil level — not in the additional-members ArrayInput.
 */
export function resolveSabilEditItsNo(
  data: Record<string, unknown>,
  sabilType: string
): string | null | undefined {
  if (isMuttavatteenSabilType(sabilType)) {
    const itsNo = data.itsNo;
    if (itsNo === null || itsNo === undefined || itsNo === "") {
      return itsNo as null | undefined;
    }
    return String(itsNo);
  }

  const itsNo = data.itsNo;
  if (itsNo === null || itsNo === undefined || itsNo === "") {
    return itsNo as null | undefined;
  }
  return String(itsNo);
}
